import React from 'react';

const Footer: React.FC = () => {
  return (
    <footer className="bg-[#15213A] text-gray-300 py-8 text-center text-sm">
      <div className="container mx-auto px-4">
        <p>© 2025 Kloud Skool. All rights reserved.</p>
        <p className="mt-2">
          Need help? Contact us at{' '}
          <a 
            href="mailto:support@kloudskool.com" 
            className="text-[#1C98ED] hover:text-[#1C98ED]/80 transition-colors"
          >
            support@kloudskool.com
          </a>
        </p>
      </div>
    </footer>
  );
};

export default Footer; 